import React from 'react'
import { ToastContainer } from 'react-toastify';
import Spinner from '../Spinner/spinner';
import UseEditCountry from './Hooks/useEditCountry';

const EditCountry = () => {
    const { spinner, countryEdit } = UseEditCountry()
    return (
        <>
            <ToastContainer />
            <section>
                <div className="cus-padd cusheight">
                    {spinner ? <Spinner /> : null}
                    <header>
                        <h2 className='page-tittle'>
                            Edit Country
                        </h2>
                        <hr />
                    </header>
                    <form className="row g-3 mt-4" onSubmit={countryEdit.handleSubmit}>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Country Code *</label>
                            <input type="text" className="form-control"
                                id="recipient-name"
                                name='code'
                                onChange={countryEdit.handleChange}
                                value={countryEdit.values.code}
                            />
                            {countryEdit.touched.code && countryEdit.errors.code ? (
                                <div style={{ color: "red", fontSize: "12px" }}>
                                    {countryEdit.errors.code}
                                </div>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Country Name *</label>
                            <input type="text" className="form-control"
                                id="recipient-name"
                                name='name'
                                onChange={countryEdit.handleChange}
                                value={countryEdit.values.name}
                            />
                            {countryEdit.touched.name && countryEdit.errors.name ? (
                                <div style={{ color: "red", fontSize: "12px" }}>
                                    {countryEdit.errors.name}
                                </div>
                            ) : null}
                        </div>
                        <p>* Note : Please fill all the mandatory fields</p>
                        < div>
                            <button type="submit" className="btn btn-primary col-0">Submit</button>
                        </div>
                    </form>
                </div>
            </section>
        </>
    )
}

export default EditCountry